import request from '../utils/request';
import { downloadFile } from '../utils/download';

// 视频设备使用率报表接口
export const getVideoUsageRateReport = ({
  startDate,
  endDate,
  pageNo,
  pageSize,
  locale,
  token
}) => {
  const url = `/smartmeeting/smart/hyreport/findRoomVideoUsage?token=${token}&startDate=${startDate}&endDate=${endDate}&pageNo=${pageNo}&pageSize=${pageSize}&lang=${locale}`;
  return request(url);
};

export const downloadHyReport = ({
  locale,
  token,
  mode,
  startDate,
  endDate,
  searchType,
  dept
}) => {
  const url = `/smartmeeting/smart/hyreport/hyExportCsv?token=${token}&lang=${locale}&mode=${mode}&startDate=${startDate}&endDate=${endDate}&searchType=${searchType}&dept=${dept ||
    ''}`;
  downloadFile('', url);
};

export const getAllCustomReport = () => {
  return request('/smartmeeting/smart/third/customReports');
};

export const excuteSQL = (sql, page, size) => {
  const url = `/smartmeeting/smart/third/sqlResult?page=${page}&size=${size}`;
  return request(url, { method: 'POST', body: JSON.stringify({ sql: sql }) });
};

export const saveCr = (id, name, script, token) => {
  const url = '/smartmeeting/smart/third/customReport';
  return request(url, {
    method: 'POST',
    body: JSON.stringify({
      id: id,
      name: name,
      script: script,
      token: token
    })
  });
};

export const dropCr = (id, token) => {
  return request(
    `/smartmeeting/smart/third/dropCustomReport?id=${id}&token=${token}`
  );
};

export const oneCr = id => {
  return request(`/smartmeeting/smart/third/oneCustomReport?id=${id}`);
};

export const sqlShow = (page, id, size) => {
  return request(
    `/smartmeeting/smart/third/sqlResultShow?id=${id}&page=${page}&size=${size}`
  );
};

export const downloadCustomReport = ({ id, token, locale }) => {
  const url = `/smartmeeting/smart/third/sqlResultExport?token=${token}&lang=${locale}&id=${id}`;
  downloadFile('', url);
};



// WEBPACK FOOTER //
// ./src/services/reportService.js